/** @format */

import React, { memo } from 'react';

import { Link } from 'gatsby-plugin-intl';
import styled from 'styled-components';

import { useAppSelector } from '../../redux/hooks';
import { mediaQuery } from '../../theme/mediaQuery';
import { utilityCalculateBreadCrumbs } from '../../utils/jsonLD/calculateBreadCrumbs';
import { TLocale } from '@/utils/gatsby/types';
import { selectorPoi } from '../../@ducks/listing/selectors';

// #region STYLED
const BreadcrumbWrapper = styled.ul<{ isPaddingListing?: boolean }>`
  font-size: 10px;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  text-align: left;
  margin: 0;
  ${mediaQuery.md`
    display: inline-block;
  `}
`;

const BreadcrumbItem = styled.li`
  display: inline-block;
  text-transform: capitalize;
  color: #aeb8c0;
  padding-right: 5px;
  & + &:before {
    content: '>';
    padding-right: 5px;
    color: #aeb8c0;
  }
`;

const BreadcrumbLink = styled(Link)`
  color: #aeb8c0;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.joivy.black};
  }
`;

// #endregion
interface Props {
  currentPage: string;
  skipLink?: string;
  listingUrl?: string;
  removeItem?: string | null;
  isPaddingListing?: boolean;
  language: TLocale;
}

const BreadCrumbs = memo(({ language, currentPage, skipLink, listingUrl, removeItem, isPaddingListing }: Props) => {
  const areaPoi = useAppSelector(selectorPoi);
  const breadCrumbsItems = utilityCalculateBreadCrumbs(currentPage, language, listingUrl, removeItem);

  return (
    <BreadcrumbWrapper isPaddingListing={isPaddingListing}>
      {breadCrumbsItems.map(item => {
        const formattedLabel = item.name.replace(/_|-/g, ' ');

        return (
          <BreadcrumbItem key={item.position}>
            {!item.active && item.name !== `${skipLink?.toLowerCase().replace(/_|-/g, ' ')}` ? (
              Object.entries(areaPoi).length === 1 ? (
                <BreadcrumbLink to={item.url.substring(3)}>{formattedLabel}</BreadcrumbLink>
              ) : (
                <BreadcrumbLink to={item.url.substring(3)}>{formattedLabel}</BreadcrumbLink>
              )
            ) : (
              formattedLabel
            )}
          </BreadcrumbItem>
        );
      })}
    </BreadcrumbWrapper>
  );
});

export default BreadCrumbs;
